/* tslint:disable */
/* eslint-disable */
/**
 * SUREnet crm-internal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CollectionResultOfCrmAdviseursGetAdviseursDto
 */
export interface CollectionResultOfCrmAdviseursGetAdviseursDto {
    /**
     * 
     * @type {Array<CrmAdviseursGetAdviseursDto>}
     * @memberof CollectionResultOfCrmAdviseursGetAdviseursDto
     */
    result: Array<CrmAdviseursGetAdviseursDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfCrmAfdelingAfdelingDto
 */
export interface CollectionResultOfCrmAfdelingAfdelingDto {
    /**
     * 
     * @type {Array<CrmAfdelingAfdelingDto>}
     * @memberof CollectionResultOfCrmAfdelingAfdelingDto
     */
    result: Array<CrmAfdelingAfdelingDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto
 */
export interface CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto {
    /**
     * 
     * @type {Array<CrmGebruikersGetGebruikersLikeStringDto>}
     * @memberof CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto
     */
    result: Array<CrmGebruikersGetGebruikersLikeStringDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfCrmGmsGetGmsConversieLogsResponse
 */
export interface CollectionResultOfCrmGmsGetGmsConversieLogsResponse {
    /**
     * 
     * @type {Array<CrmGmsGetGmsConversieLogsResponse>}
     * @memberof CollectionResultOfCrmGmsGetGmsConversieLogsResponse
     */
    result: Array<CrmGmsGetGmsConversieLogsResponse>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfCrmMedewerkersAfdelingGebruikers
 */
export interface CollectionResultOfCrmMedewerkersAfdelingGebruikers {
    /**
     * 
     * @type {Array<CrmMedewerkersAfdelingGebruikers>}
     * @memberof CollectionResultOfCrmMedewerkersAfdelingGebruikers
     */
    result: Array<CrmMedewerkersAfdelingGebruikers>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfCrmMedewerkersMedewerkerDto
 */
export interface CollectionResultOfCrmMedewerkersMedewerkerDto {
    /**
     * 
     * @type {Array<CrmMedewerkersMedewerkerDto>}
     * @memberof CollectionResultOfCrmMedewerkersMedewerkerDto
     */
    result: Array<CrmMedewerkersMedewerkerDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfCrmRelationsGetNaselectiesResponse
 */
export interface CollectionResultOfCrmRelationsGetNaselectiesResponse {
    /**
     * 
     * @type {Array<CrmRelationsGetNaselectiesResponse>}
     * @memberof CollectionResultOfCrmRelationsGetNaselectiesResponse
     */
    result: Array<CrmRelationsGetNaselectiesResponse>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
 */
export interface CollectionResultOfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult {
    /**
     * 
     * @type {Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult>}
     * @memberof CollectionResultOfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
     */
    result: Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfCrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie
 */
export interface CollectionResultOfCrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie {
    /**
     * 
     * @type {Array<CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie>}
     * @memberof CollectionResultOfCrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie
     */
    result: Array<CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie>;
}
/**
 * 
 * @export
 * @interface CrmAdressenVoegAdresToeDto
 */
export interface CrmAdressenVoegAdresToeDto {
    /**
     * 
     * @type {string}
     * @memberof CrmAdressenVoegAdresToeDto
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof CrmAdressenVoegAdresToeDto
     */
    plaats: string;
    /**
     * 
     * @type {string}
     * @memberof CrmAdressenVoegAdresToeDto
     */
    plaatsKort: string;
    /**
     * 
     * @type {string}
     * @memberof CrmAdressenVoegAdresToeDto
     */
    straat: string;
    /**
     * 
     * @type {string}
     * @memberof CrmAdressenVoegAdresToeDto
     */
    straatKort: string;
    /**
     * 
     * @type {number}
     * @memberof CrmAdressenVoegAdresToeDto
     */
    huisnummer: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrmAdressenVoegAdresToeDto
     */
    toevoegingen: Array<string>;
}
/**
 * 
 * @export
 * @interface CrmAdviseursGetAdviseursDto
 */
export interface CrmAdviseursGetAdviseursDto {
    /**
     * 
     * @type {number}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    adviseurnummer: number;
    /**
     * 
     * @type {string}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    emailadres?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    telefoonnummer?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    defaultHoofdvervaldatumDag?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    defaultHoofdvervaldatumMaand?: number | null;
    /**
     * 
     * @type {CrmDomainDomainAdviseursDirectePostVerzending}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    defaultDirectePostVerzending?: CrmDomainDomainAdviseursDirectePostVerzending;
    /**
     * 
     * @type {boolean}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    mailVersturenVanuitSUREnet: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    isZelfIncasserend: boolean;
    /**
     * 
     * @type {string}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    accountmanager: string;
    /**
     * 
     * @type {SUREbusinessCommonDomainAdviseurStatus}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    status: SUREbusinessCommonDomainAdviseurStatus;
    /**
     * 
     * @type {SUREbusinessCommonDomainValueObjectsAdres}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    bezoekadres?: SUREbusinessCommonDomainValueObjectsAdres;
    /**
     * 
     * @type {CrmDomainDomainAdviseursAdviseurType}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    type: CrmDomainDomainAdviseursAdviseurType;
    /**
     * 
     * @type {boolean}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    aanvragenGeblokkeerd: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    beheerstatus: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    emailPremieOvertijd: boolean;
    /**
     * 
     * @type {Array<SUREbusinessCommonDomainMarktsegment>}
     * @memberof CrmAdviseursGetAdviseursDto
     */
    marktsegmenten: Array<SUREbusinessCommonDomainMarktsegment>;
}
/**
 * 
 * @export
 * @interface CrmAfdelingAfdelingDto
 */
export interface CrmAfdelingAfdelingDto {
    /**
     * 
     * @type {number}
     * @memberof CrmAfdelingAfdelingDto
     */
    afdelingId: number;
    /**
     * 
     * @type {string}
     * @memberof CrmAfdelingAfdelingDto
     */
    omschrijving: string;
    /**
     * 
     * @type {CrmDomainDomainAdviseursAfdelingSoort}
     * @memberof CrmAfdelingAfdelingDto
     */
    soort: CrmDomainDomainAdviseursAfdelingSoort;
    /**
     * 
     * @type {number}
     * @memberof CrmAfdelingAfdelingDto
     */
    werkverdeler?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CrmAfdelingAfdelingDto
     */
    email?: string | null;
}
/**
 * 
 * @export
 * @interface CrmApplicationServicesAdres
 */
export interface CrmApplicationServicesAdres {
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesAdres
     */
    straat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesAdres
     */
    huisnummer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesAdres
     */
    postcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesAdres
     */
    stad?: string | null;
}
/**
 * 
 * @export
 * @interface CrmApplicationServicesFishToetsResponse
 */
export interface CrmApplicationServicesFishToetsResponse {
    /**
     * 
     * @type {CrmApplicationServicesZoekResultaat}
     * @memberof CrmApplicationServicesFishToetsResponse
     */
    zoekResult: CrmApplicationServicesZoekResultaat;
}
/**
 * 
 * @export
 * @interface CrmApplicationServicesGevondenRegistratie
 */
export interface CrmApplicationServicesGevondenRegistratie {
    /**
     * 
     * @type {number}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    referentienummer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    referentiedatum?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    verzekeraar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    afhandelaar?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    organisatieType?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    meldingSoortCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    meldingSoortCodeOmschrijving?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    claimbedrag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    uitgekeerdeBedrag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    branchCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    branchCodeOmschrijving?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    oorzaakCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    oorzaakCodeOmschrijving?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    reden?: string | null;
    /**
     * 
     * @type {Array<CrmApplicationServicesPartij>}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    partijen?: Array<CrmApplicationServicesPartij> | null;
    /**
     * 
     * @type {number}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    volgnummerIncident?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    waarschijnlijkheidsscore?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    waarschijnlijkheidscategorie?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrmApplicationServicesGevondenRegistratie
     */
    idsGeraakteKennisregels?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CrmApplicationServicesIdentificatie
 */
export interface CrmApplicationServicesIdentificatie {
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesIdentificatie
     */
    identificatieType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesIdentificatie
     */
    identificatieWaarde?: string | null;
}
/**
 * 
 * @export
 * @interface CrmApplicationServicesObject
 */
export interface CrmApplicationServicesObject {
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesObject
     */
    type?: string | null;
    /**
     * 
     * @type {Array<CrmApplicationServicesIdentificatie>}
     * @memberof CrmApplicationServicesObject
     */
    identificaties?: Array<CrmApplicationServicesIdentificatie> | null;
}
/**
 * 
 * @export
 * @interface CrmApplicationServicesPartij
 */
export interface CrmApplicationServicesPartij {
    /**
     * 
     * @type {number}
     * @memberof CrmApplicationServicesPartij
     */
    id: number;
    /**
     * 
     * @type {CrmApplicationServicesPersoon}
     * @memberof CrmApplicationServicesPartij
     */
    personen?: CrmApplicationServicesPersoon;
    /**
     * 
     * @type {CrmApplicationServicesAdres}
     * @memberof CrmApplicationServicesPartij
     */
    adres?: CrmApplicationServicesAdres;
    /**
     * 
     * @type {Array<CrmApplicationServicesObject>}
     * @memberof CrmApplicationServicesPartij
     */
    objecten?: Array<CrmApplicationServicesObject> | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesPartij
     */
    rolOmschrijving?: string | null;
}
/**
 * 
 * @export
 * @interface CrmApplicationServicesPersoon
 */
export interface CrmApplicationServicesPersoon {
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesPersoon
     */
    initialen?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesPersoon
     */
    achternaam?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesPersoon
     */
    geboortedatum?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesPersoon
     */
    gender?: string | null;
}
/**
 * 
 * @export
 * @interface CrmApplicationServicesZoekResultaat
 */
export interface CrmApplicationServicesZoekResultaat {
    /**
     * 
     * @type {string}
     * @memberof CrmApplicationServicesZoekResultaat
     */
    status: string;
    /**
     * 
     * @type {Array<CrmApplicationServicesGevondenRegistratie>}
     * @memberof CrmApplicationServicesZoekResultaat
     */
    registraties: Array<CrmApplicationServicesGevondenRegistratie>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CrmDomainDomainActieStatus {
    TerBeoordeling = 'TerBeoordeling',
    GeenActie = 'GeenActie',
    WaarschuwingVerstuurd = 'WaarschuwingVerstuurd',
    Royeren = 'Royeren',
    ActieOndernomen = 'ActieOndernomen'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum CrmDomainDomainAdviseursAdviseurType {
    Regulier = 'Regulier',
    Demo = 'Demo',
    Maatschappij = 'Maatschappij',
    Intern = 'Intern'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum CrmDomainDomainAdviseursAfdelingSoort {
    Acceptatie = 'Acceptatie',
    Schade = 'Schade',
    Overvoer = 'Overvoer',
    Accountmanagement = 'Accountmanagement',
    Administratie = 'Administratie',
    Financieel = 'Financieel',
    Overig = 'Overig'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum CrmDomainDomainAdviseursDirectePostVerzending {
    Adviseur = 'Adviseur',
    AdviseurEnRelatie = 'AdviseurEnRelatie',
    Relatie = 'Relatie'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum CrmDomainDomainVeelgesteldeVragenVeelgesteldeVraagStatus {
    Inactief = 'Inactief',
    Actief = 'Actief'
}

/**
 * 
 * @export
 * @interface CrmGebruikersGebruikerDto
 */
export interface CrmGebruikersGebruikerDto {
    /**
     * 
     * @type {number}
     * @memberof CrmGebruikersGebruikerDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGebruikerDto
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGebruikerDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGebruikerDto
     */
    naam?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGebruikerDto
     */
    voornaam?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGebruikerDto
     */
    voorletters?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGebruikerDto
     */
    initialen: string;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGebruikerDto
     */
    tussenvoegsels?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CrmGebruikersGebruikerDto
     */
    advisorId: number;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGebruikerDto
     */
    advisorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGebruikerDto
     */
    volledigeNaam: string;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGebruikerDto
     */
    geslacht?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmGebruikersGebruikerDto
     */
    bevestigingPolisDirectNaarRelatie: boolean;
    /**
     * 
     * @type {number}
     * @memberof CrmGebruikersGebruikerDto
     */
    medewerkernrCcs?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGebruikerDto
     */
    telefoonnummer?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CrmGebruikersGebruikerDto
     */
    afdelingen: Array<number>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CrmGebruikersGebruikerType {
    Systeem = 'Systeem',
    Intern = 'Intern',
    Test = 'Test',
    Demo = 'Demo',
    Adviseur = 'Adviseur',
    Maatschappij = 'Maatschappij'
}

/**
 * 
 * @export
 * @interface CrmGebruikersGetGebruikersLikeStringDto
 */
export interface CrmGebruikersGetGebruikersLikeStringDto {
    /**
     * 
     * @type {number}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    naam?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    voornaam?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    voorletters?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    tussenvoegsel?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    advisorId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    advisorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    volledigeNaam?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    telefoonnummer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    accountmanager?: string | null;
}
/**
 * 
 * @export
 * @interface CrmGmsGetGmsConversieLogsResponse
 */
export interface CrmGmsGetGmsConversieLogsResponse {
    /**
     * 
     * @type {string}
     * @memberof CrmGmsGetGmsConversieLogsResponse
     */
    polisnummer: string;
    /**
     * 
     * @type {string}
     * @memberof CrmGmsGetGmsConversieLogsResponse
     */
    reden: string;
}
/**
 * 
 * @export
 * @interface CrmGmsVerstuurGmsCommunicatieRequest
 */
export interface CrmGmsVerstuurGmsCommunicatieRequest {
    /**
     * 
     * @type {string}
     * @memberof CrmGmsVerstuurGmsCommunicatieRequest
     */
    mutatiedatum: string;
    /**
     * 
     * @type {number}
     * @memberof CrmGmsVerstuurGmsCommunicatieRequest
     */
    mutatiereden: number;
    /**
     * 
     * @type {string}
     * @memberof CrmGmsVerstuurGmsCommunicatieRequest
     */
    onderwerp: string;
    /**
     * 
     * @type {string}
     * @memberof CrmGmsVerstuurGmsCommunicatieRequest
     */
    mailtext: string;
    /**
     * 
     * @type {string}
     * @memberof CrmGmsVerstuurGmsCommunicatieRequest
     */
    onderwerpAdviseur: string;
    /**
     * 
     * @type {string}
     * @memberof CrmGmsVerstuurGmsCommunicatieRequest
     */
    mailtextAdviseur: string;
}
/**
 * 
 * @export
 * @interface CrmMedewerkersAfdelingGebruikers
 */
export interface CrmMedewerkersAfdelingGebruikers {
    /**
     * 
     * @type {number}
     * @memberof CrmMedewerkersAfdelingGebruikers
     */
    afdelingId: number;
    /**
     * 
     * @type {string}
     * @memberof CrmMedewerkersAfdelingGebruikers
     */
    afdelingNaam: string;
    /**
     * 
     * @type {Array<CrmMedewerkersMedewerkerDto>}
     * @memberof CrmMedewerkersAfdelingGebruikers
     */
    medewerkers: Array<CrmMedewerkersMedewerkerDto>;
}
/**
 * 
 * @export
 * @interface CrmMedewerkersMedewerkerDto
 */
export interface CrmMedewerkersMedewerkerDto {
    /**
     * 
     * @type {number}
     * @memberof CrmMedewerkersMedewerkerDto
     */
    gebruikerId: number;
    /**
     * 
     * @type {string}
     * @memberof CrmMedewerkersMedewerkerDto
     */
    naam: string;
    /**
     * 
     * @type {boolean}
     * @memberof CrmMedewerkersMedewerkerDto
     */
    isWerkverdeler: boolean;
}
/**
 * 
 * @export
 * @interface CrmRelationsGetNaselectiesResponse
 */
export interface CrmRelationsGetNaselectiesResponse {
    /**
     * 
     * @type {number}
     * @memberof CrmRelationsGetNaselectiesResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CrmRelationsGetNaselectiesResponse
     */
    notitie?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CrmRelationsGetNaselectiesResponse
     */
    gebruikerId: number;
    /**
     * 
     * @type {string}
     * @memberof CrmRelationsGetNaselectiesResponse
     */
    tijdstip: string;
    /**
     * 
     * @type {CrmDomainDomainActieStatus}
     * @memberof CrmRelationsGetNaselectiesResponse
     */
    actieStatus: CrmDomainDomainActieStatus;
}
/**
 * 
 * @export
 * @interface CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto
 */
export interface CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto {
    /**
     * 
     * @type {number}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto
     */
    ingebruik: boolean;
}
/**
 * 
 * @export
 * @interface CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto
 */
export interface CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto {
    /**
     * 
     * @type {number}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto
     */
    relatienummer: number;
    /**
     * 
     * @type {Array<CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto>}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto
     */
    contactpersonen: Array<CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto>;
}
/**
 * 
 * @export
 * @interface CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
 */
export interface CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult {
    /**
     * 
     * @type {number}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
     */
    relatienummer: number;
    /**
     * 
     * @type {Array<CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto>}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
     */
    contactpersonen: Array<CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
     */
    verwijderd: Array<number>;
}
/**
 * 
 * @export
 * @interface CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie
 */
export interface CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie {
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie
     */
    naam: string;
    /**
     * 
     * @type {number}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie
     */
    volgorde: number;
    /**
     * 
     * @type {CrmDomainDomainVeelgesteldeVragenVeelgesteldeVraagStatus}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie
     */
    status: CrmDomainDomainVeelgesteldeVragenVeelgesteldeVraagStatus;
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie
     */
    aangemaakt: string;
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie
     */
    laatstGewijzigd: string;
    /**
     * 
     * @type {Array<CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem>}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie
     */
    vragen: Array<CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem>;
}
/**
 * 
 * @export
 * @interface CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem
 */
export interface CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem {
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem
     */
    categorieId: string;
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem
     */
    vraag: string;
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem
     */
    antwoordMarkdown: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem
     */
    zoekwoorden: Array<string>;
    /**
     * 
     * @type {Array<SUREbusinessCommonDomainMarktsegment>}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem
     */
    marktsegmenten: Array<SUREbusinessCommonDomainMarktsegment>;
    /**
     * 
     * @type {number}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem
     */
    volgorde: number;
    /**
     * 
     * @type {CrmDomainDomainVeelgesteldeVragenVeelgesteldeVraagStatus}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem
     */
    status: CrmDomainDomainVeelgesteldeVragenVeelgesteldeVraagStatus;
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem
     */
    aangemaakt: string;
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerItem
     */
    laatstGewijzigd: string;
}
/**
 * 
 * @export
 * @interface CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto
 */
export interface CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto {
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto
     */
    naam: string;
    /**
     * 
     * @type {CrmDomainDomainVeelgesteldeVragenVeelgesteldeVraagStatus}
     * @memberof CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto
     */
    status: CrmDomainDomainVeelgesteldeVragenVeelgesteldeVraagStatus;
}
/**
 * 
 * @export
 * @interface CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto
 */
export interface CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto {
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto
     */
    categorieId: string;
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto
     */
    vraag: string;
    /**
     * 
     * @type {string}
     * @memberof CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto
     */
    antwoordMarkdown: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto
     */
    zoekwoorden: Array<string>;
    /**
     * 
     * @type {Array<SUREbusinessCommonDomainMarktsegment>}
     * @memberof CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto
     */
    marktsegmenten: Array<SUREbusinessCommonDomainMarktsegment>;
    /**
     * 
     * @type {CrmDomainDomainVeelgesteldeVragenVeelgesteldeVraagStatus}
     * @memberof CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto
     */
    status: CrmDomainDomainVeelgesteldeVragenVeelgesteldeVraagStatus;
}
/**
 * 
 * @export
 * @interface CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto
 */
export interface CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto {
    /**
     * 
     * @type {number}
     * @memberof CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto
     */
    volgorde: number;
}
/**
 * 
 * @export
 * @interface MicrosoftAspNetCoreHttpHttpValidationProblemDetails
 */
export interface MicrosoftAspNetCoreHttpHttpValidationProblemDetails extends MicrosoftAspNetCoreMvcProblemDetails {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof MicrosoftAspNetCoreHttpHttpValidationProblemDetails
     */
    errors: { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface MicrosoftAspNetCoreMvcProblemDetails
 */
export interface MicrosoftAspNetCoreMvcProblemDetails {
    [key: string]: any | any;

    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    typeName: string;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    title?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    status?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    detail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    instance?: string | null;
}
/**
 * 
 * @export
 * @interface Result1OfCrmApplicationServicesFishToetsResponse
 */
export interface Result1OfCrmApplicationServicesFishToetsResponse {
    /**
     * 
     * @type {CrmApplicationServicesFishToetsResponse}
     * @memberof Result1OfCrmApplicationServicesFishToetsResponse
     */
    result: CrmApplicationServicesFishToetsResponse;
}
/**
 * 
 * @export
 * @interface Result1OfCrmGebruikersGebruikerDto
 */
export interface Result1OfCrmGebruikersGebruikerDto {
    /**
     * 
     * @type {CrmGebruikersGebruikerDto}
     * @memberof Result1OfCrmGebruikersGebruikerDto
     */
    result: CrmGebruikersGebruikerDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum SUREbusinessCommonDomainAdviseurStatus {
    Actief = 'Actief',
    Beeindigd = 'Beeindigd',
    Geblokkeerd = 'Geblokkeerd',
    Kandidaat = 'Kandidaat',
    Onbekend = 'Onbekend'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum SUREbusinessCommonDomainMarktsegment {
    Particulier = 'Particulier',
    Zakelijk = 'Zakelijk'
}

/**
 * 
 * @export
 * @interface SUREbusinessCommonDomainValueObjectsAdres
 */
export interface SUREbusinessCommonDomainValueObjectsAdres {
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsAdres
     */
    postcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsAdres
     */
    plaats?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsAdres
     */
    straat?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SUREbusinessCommonDomainValueObjectsAdres
     */
    huisnummer?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsAdres
     */
    huisnummertoevoeging?: string | null;
}

/**
 * AdresApi - axios parameter creator
 * @export
 */
export const AdresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.HandmatigAdresToevoegen</li></ul>
         * @summary Voegt een adres toe voor als deze niet opgehaald kan worden via de postcode API
         * @param {CrmAdressenVoegAdresToeDto} [crmAdressenVoegAdresToeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adresAdresToevoegen: async (crmAdressenVoegAdresToeDto?: CrmAdressenVoegAdresToeDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/adres`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crmAdressenVoegAdresToeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdresApi - functional programming interface
 * @export
 */
export const AdresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdresApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.HandmatigAdresToevoegen</li></ul>
         * @summary Voegt een adres toe voor als deze niet opgehaald kan worden via de postcode API
         * @param {CrmAdressenVoegAdresToeDto} [crmAdressenVoegAdresToeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adresAdresToevoegen(crmAdressenVoegAdresToeDto?: CrmAdressenVoegAdresToeDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adresAdresToevoegen(crmAdressenVoegAdresToeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdresApi - factory interface
 * @export
 */
export const AdresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdresApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.HandmatigAdresToevoegen</li></ul>
         * @summary Voegt een adres toe voor als deze niet opgehaald kan worden via de postcode API
         * @param {CrmAdressenVoegAdresToeDto} [crmAdressenVoegAdresToeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adresAdresToevoegen(crmAdressenVoegAdresToeDto?: CrmAdressenVoegAdresToeDto, options?: any): AxiosPromise<void> {
            return localVarFp.adresAdresToevoegen(crmAdressenVoegAdresToeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdresApi - interface
 * @export
 * @interface AdresApi
 */
export interface AdresApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.HandmatigAdresToevoegen</li></ul>
     * @summary Voegt een adres toe voor als deze niet opgehaald kan worden via de postcode API
     * @param {CrmAdressenVoegAdresToeDto} [crmAdressenVoegAdresToeDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresApiInterface
     */
    adresAdresToevoegen(crmAdressenVoegAdresToeDto?: CrmAdressenVoegAdresToeDto, options?: any): AxiosPromise<void>;

}

/**
 * AdresApi - object-oriented interface
 * @export
 * @class AdresApi
 * @extends {BaseAPI}
 */
export class AdresApi extends BaseAPI implements AdresApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.HandmatigAdresToevoegen</li></ul>
     * @summary Voegt een adres toe voor als deze niet opgehaald kan worden via de postcode API
     * @param {CrmAdressenVoegAdresToeDto} [crmAdressenVoegAdresToeDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresApi
     */
    public adresAdresToevoegen(crmAdressenVoegAdresToeDto?: CrmAdressenVoegAdresToeDto, options?: any) {
        return AdresApiFp(this.configuration).adresAdresToevoegen(crmAdressenVoegAdresToeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AfdelingenApiApi - axios parameter creator
 * @export
 */
export const AfdelingenApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Dit zijn alle afdelingen die behoren aan adviseur 1 <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haal alle interne afdelingen op
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        afdelingenGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/afdelingen/intern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AfdelingenApiApi - functional programming interface
 * @export
 */
export const AfdelingenApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AfdelingenApiApiAxiosParamCreator(configuration)
    return {
        /**
         * Dit zijn alle afdelingen die behoren aan adviseur 1 <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haal alle interne afdelingen op
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async afdelingenGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmAfdelingAfdelingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.afdelingenGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AfdelingenApiApi - factory interface
 * @export
 */
export const AfdelingenApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AfdelingenApiApiFp(configuration)
    return {
        /**
         * Dit zijn alle afdelingen die behoren aan adviseur 1 <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haal alle interne afdelingen op
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        afdelingenGet(options?: any): AxiosPromise<CollectionResultOfCrmAfdelingAfdelingDto> {
            return localVarFp.afdelingenGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AfdelingenApiApi - interface
 * @export
 * @interface AfdelingenApiApi
 */
export interface AfdelingenApiApiInterface {
    /**
     * Dit zijn alle afdelingen die behoren aan adviseur 1 <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
     * @summary Haal alle interne afdelingen op
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AfdelingenApiApiInterface
     */
    afdelingenGet(options?: any): AxiosPromise<CollectionResultOfCrmAfdelingAfdelingDto>;

}

/**
 * AfdelingenApiApi - object-oriented interface
 * @export
 * @class AfdelingenApiApi
 * @extends {BaseAPI}
 */
export class AfdelingenApiApi extends BaseAPI implements AfdelingenApiApiInterface {
    /**
     * Dit zijn alle afdelingen die behoren aan adviseur 1 <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
     * @summary Haal alle interne afdelingen op
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AfdelingenApiApi
     */
    public afdelingenGet(options?: any) {
        return AfdelingenApiApiFp(this.configuration).afdelingenGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FishApiApi - axios parameter creator
 * @export
 */
export const FishApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.FishToetsUitvoeren</li></ul>
         * @summary Haal Fish resultaten op bij relatienummer.
         * @param {number} relatienummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fishGetFishResult: async (relatienummer: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'relatienummer' is not null or undefined
            assertParamExists('fishGetFishResult', 'relatienummer', relatienummer)
            const localVarPath = `/api/v1/relaties-intern/fish/{relatienummer}/check`
                .replace(`{${"relatienummer"}}`, encodeURIComponent(String(relatienummer)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FishApiApi - functional programming interface
 * @export
 */
export const FishApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FishApiApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.FishToetsUitvoeren</li></ul>
         * @summary Haal Fish resultaten op bij relatienummer.
         * @param {number} relatienummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fishGetFishResult(relatienummer: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfCrmApplicationServicesFishToetsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fishGetFishResult(relatienummer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FishApiApi - factory interface
 * @export
 */
export const FishApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FishApiApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.FishToetsUitvoeren</li></ul>
         * @summary Haal Fish resultaten op bij relatienummer.
         * @param {number} relatienummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fishGetFishResult(relatienummer: number, options?: any): AxiosPromise<Result1OfCrmApplicationServicesFishToetsResponse> {
            return localVarFp.fishGetFishResult(relatienummer, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FishApiApi - interface
 * @export
 * @interface FishApiApi
 */
export interface FishApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.FishToetsUitvoeren</li></ul>
     * @summary Haal Fish resultaten op bij relatienummer.
     * @param {number} relatienummer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FishApiApiInterface
     */
    fishGetFishResult(relatienummer: number, options?: any): AxiosPromise<Result1OfCrmApplicationServicesFishToetsResponse>;

}

/**
 * FishApiApi - object-oriented interface
 * @export
 * @class FishApiApi
 * @extends {BaseAPI}
 */
export class FishApiApi extends BaseAPI implements FishApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.FishToetsUitvoeren</li></ul>
     * @summary Haal Fish resultaten op bij relatienummer.
     * @param {number} relatienummer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FishApiApi
     */
    public fishGetFishResult(relatienummer: number, options?: any) {
        return FishApiApiFp(this.configuration).fishGetFishResult(relatienummer, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ForceerBijwerkenRelatieApi - axios parameter creator
 * @export
 */
export const ForceerBijwerkenRelatieApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Rechtvormen bijwerken op relaties waarbij deze ontbreekt.
         * @param {number} [maxRows] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceerBijwerkenRelatieRechtsvormenGeforceerdWijzigen: async (maxRows?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/relatie/bijwerkenforceren/rechtsvorm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (maxRows !== undefined) {
                localVarQueryParameter['maxRows'] = maxRows;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForceerBijwerkenRelatieApi - functional programming interface
 * @export
 */
export const ForceerBijwerkenRelatieApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ForceerBijwerkenRelatieApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Rechtvormen bijwerken op relaties waarbij deze ontbreekt.
         * @param {number} [maxRows] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forceerBijwerkenRelatieRechtsvormenGeforceerdWijzigen(maxRows?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forceerBijwerkenRelatieRechtsvormenGeforceerdWijzigen(maxRows, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ForceerBijwerkenRelatieApi - factory interface
 * @export
 */
export const ForceerBijwerkenRelatieApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ForceerBijwerkenRelatieApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Rechtvormen bijwerken op relaties waarbij deze ontbreekt.
         * @param {number} [maxRows] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceerBijwerkenRelatieRechtsvormenGeforceerdWijzigen(maxRows?: number, options?: any): AxiosPromise<string> {
            return localVarFp.forceerBijwerkenRelatieRechtsvormenGeforceerdWijzigen(maxRows, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ForceerBijwerkenRelatieApi - interface
 * @export
 * @interface ForceerBijwerkenRelatieApi
 */
export interface ForceerBijwerkenRelatieApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Rechtvormen bijwerken op relaties waarbij deze ontbreekt.
     * @param {number} [maxRows] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForceerBijwerkenRelatieApiInterface
     */
    forceerBijwerkenRelatieRechtsvormenGeforceerdWijzigen(maxRows?: number, options?: any): AxiosPromise<string>;

}

/**
 * ForceerBijwerkenRelatieApi - object-oriented interface
 * @export
 * @class ForceerBijwerkenRelatieApi
 * @extends {BaseAPI}
 */
export class ForceerBijwerkenRelatieApi extends BaseAPI implements ForceerBijwerkenRelatieApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Rechtvormen bijwerken op relaties waarbij deze ontbreekt.
     * @param {number} [maxRows] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForceerBijwerkenRelatieApi
     */
    public forceerBijwerkenRelatieRechtsvormenGeforceerdWijzigen(maxRows?: number, options?: any) {
        return ForceerBijwerkenRelatieApiFp(this.configuration).forceerBijwerkenRelatieRechtsvormenGeforceerdWijzigen(maxRows, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GebruikerApiApi - axios parameter creator
 * @export
 */
export const GebruikerApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.Adviseurbeheer</li></ul>
         * @summary Upload een profielfoto voor een gebruiker.
         * @param {number} gebruikerId 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gebruikerFotoUploaden: async (gebruikerId: number, file?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gebruikerId' is not null or undefined
            assertParamExists('gebruikerFotoUploaden', 'gebruikerId', gebruikerId)
            const localVarPath = `/api/v1/gebruikers/{gebruikerId}/profielfoto`
                .replace(`{${"gebruikerId"}}`, encodeURIComponent(String(gebruikerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Gebruiker ophalen
         * @param {number} gebruikerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gebruikerGet: async (gebruikerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gebruikerId' is not null or undefined
            assertParamExists('gebruikerGet', 'gebruikerId', gebruikerId)
            const localVarPath = `/api/v1/gebruikers/{gebruikerId}`
                .replace(`{${"gebruikerId"}}`, encodeURIComponent(String(gebruikerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Haal alle werkverdeling gebruikers op.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gebruikerGetWerkverdelingGebruikers: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/gebruikers/werkverdeling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Zoek naar gebruikers
         * @param {string} [term] 
         * @param {CrmGebruikersGebruikerType} [gebruikerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gebruikerSearch: async (term?: string, gebruikerType?: CrmGebruikersGebruikerType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/gebruikers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (gebruikerType !== undefined) {
                localVarQueryParameter['gebruikerType'] = gebruikerType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GebruikerApiApi - functional programming interface
 * @export
 */
export const GebruikerApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GebruikerApiApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.Adviseurbeheer</li></ul>
         * @summary Upload een profielfoto voor een gebruiker.
         * @param {number} gebruikerId 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gebruikerFotoUploaden(gebruikerId: number, file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gebruikerFotoUploaden(gebruikerId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Gebruiker ophalen
         * @param {number} gebruikerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gebruikerGet(gebruikerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfCrmGebruikersGebruikerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gebruikerGet(gebruikerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Haal alle werkverdeling gebruikers op.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gebruikerGetWerkverdelingGebruikers(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmMedewerkersMedewerkerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gebruikerGetWerkverdelingGebruikers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Zoek naar gebruikers
         * @param {string} [term] 
         * @param {CrmGebruikersGebruikerType} [gebruikerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gebruikerSearch(term?: string, gebruikerType?: CrmGebruikersGebruikerType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gebruikerSearch(term, gebruikerType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GebruikerApiApi - factory interface
 * @export
 */
export const GebruikerApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GebruikerApiApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.Adviseurbeheer</li></ul>
         * @summary Upload een profielfoto voor een gebruiker.
         * @param {number} gebruikerId 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gebruikerFotoUploaden(gebruikerId: number, file?: any, options?: any): AxiosPromise<void> {
            return localVarFp.gebruikerFotoUploaden(gebruikerId, file, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Gebruiker ophalen
         * @param {number} gebruikerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gebruikerGet(gebruikerId: number, options?: any): AxiosPromise<Result1OfCrmGebruikersGebruikerDto> {
            return localVarFp.gebruikerGet(gebruikerId, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Haal alle werkverdeling gebruikers op.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gebruikerGetWerkverdelingGebruikers(options?: any): AxiosPromise<CollectionResultOfCrmMedewerkersMedewerkerDto> {
            return localVarFp.gebruikerGetWerkverdelingGebruikers(options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Zoek naar gebruikers
         * @param {string} [term] 
         * @param {CrmGebruikersGebruikerType} [gebruikerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gebruikerSearch(term?: string, gebruikerType?: CrmGebruikersGebruikerType, options?: any): AxiosPromise<CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto> {
            return localVarFp.gebruikerSearch(term, gebruikerType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GebruikerApiApi - interface
 * @export
 * @interface GebruikerApiApi
 */
export interface GebruikerApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.Adviseurbeheer</li></ul>
     * @summary Upload een profielfoto voor een gebruiker.
     * @param {number} gebruikerId 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GebruikerApiApiInterface
     */
    gebruikerFotoUploaden(gebruikerId: number, file?: any, options?: any): AxiosPromise<void>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Gebruiker ophalen
     * @param {number} gebruikerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GebruikerApiApiInterface
     */
    gebruikerGet(gebruikerId: number, options?: any): AxiosPromise<Result1OfCrmGebruikersGebruikerDto>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Haal alle werkverdeling gebruikers op.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GebruikerApiApiInterface
     */
    gebruikerGetWerkverdelingGebruikers(options?: any): AxiosPromise<CollectionResultOfCrmMedewerkersMedewerkerDto>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Zoek naar gebruikers
     * @param {string} [term] 
     * @param {CrmGebruikersGebruikerType} [gebruikerType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GebruikerApiApiInterface
     */
    gebruikerSearch(term?: string, gebruikerType?: CrmGebruikersGebruikerType, options?: any): AxiosPromise<CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto>;

}

/**
 * GebruikerApiApi - object-oriented interface
 * @export
 * @class GebruikerApiApi
 * @extends {BaseAPI}
 */
export class GebruikerApiApi extends BaseAPI implements GebruikerApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.Adviseurbeheer</li></ul>
     * @summary Upload een profielfoto voor een gebruiker.
     * @param {number} gebruikerId 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GebruikerApiApi
     */
    public gebruikerFotoUploaden(gebruikerId: number, file?: any, options?: any) {
        return GebruikerApiApiFp(this.configuration).gebruikerFotoUploaden(gebruikerId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Gebruiker ophalen
     * @param {number} gebruikerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GebruikerApiApi
     */
    public gebruikerGet(gebruikerId: number, options?: any) {
        return GebruikerApiApiFp(this.configuration).gebruikerGet(gebruikerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Haal alle werkverdeling gebruikers op.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GebruikerApiApi
     */
    public gebruikerGetWerkverdelingGebruikers(options?: any) {
        return GebruikerApiApiFp(this.configuration).gebruikerGetWerkverdelingGebruikers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Zoek naar gebruikers
     * @param {string} [term] 
     * @param {CrmGebruikersGebruikerType} [gebruikerType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GebruikerApiApi
     */
    public gebruikerSearch(term?: string, gebruikerType?: CrmGebruikersGebruikerType, options?: any) {
        return GebruikerApiApiFp(this.configuration).gebruikerSearch(term, gebruikerType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GmsConversieApiApi - axios parameter creator
 * @export
 */
export const GmsConversieApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GmsConversieCommunicatieVersturen</li></ul>
         * @summary Haalt de resultaten op van GMS conversie.
         * @param {string} [mutatiedatum] 
         * @param {number} [mutatiereden] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gmsConversieGetResults: async (mutatiedatum?: string, mutatiereden?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/gms-conversie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mutatiedatum !== undefined) {
                localVarQueryParameter['Mutatiedatum'] = (mutatiedatum as any instanceof Date) ?
                    (mutatiedatum as any).toISOString() :
                    mutatiedatum;
            }

            if (mutatiereden !== undefined) {
                localVarQueryParameter['Mutatiereden'] = mutatiereden;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GmsConversieCommunicatieVersturen</li></ul>
         * @summary Verstuurt communicatie richting klanten m.b.t. gms conversie.
         * @param {boolean} [testRun] 
         * @param {CrmGmsVerstuurGmsCommunicatieRequest} [crmGmsVerstuurGmsCommunicatieRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gmsConversieVerstuurCommunicatie: async (testRun?: boolean, crmGmsVerstuurGmsCommunicatieRequest?: CrmGmsVerstuurGmsCommunicatieRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/gms-conversie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testRun !== undefined) {
                localVarQueryParameter['testRun'] = testRun;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crmGmsVerstuurGmsCommunicatieRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GmsConversieApiApi - functional programming interface
 * @export
 */
export const GmsConversieApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GmsConversieApiApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GmsConversieCommunicatieVersturen</li></ul>
         * @summary Haalt de resultaten op van GMS conversie.
         * @param {string} [mutatiedatum] 
         * @param {number} [mutatiereden] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gmsConversieGetResults(mutatiedatum?: string, mutatiereden?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmGmsGetGmsConversieLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gmsConversieGetResults(mutatiedatum, mutatiereden, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GmsConversieCommunicatieVersturen</li></ul>
         * @summary Verstuurt communicatie richting klanten m.b.t. gms conversie.
         * @param {boolean} [testRun] 
         * @param {CrmGmsVerstuurGmsCommunicatieRequest} [crmGmsVerstuurGmsCommunicatieRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gmsConversieVerstuurCommunicatie(testRun?: boolean, crmGmsVerstuurGmsCommunicatieRequest?: CrmGmsVerstuurGmsCommunicatieRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gmsConversieVerstuurCommunicatie(testRun, crmGmsVerstuurGmsCommunicatieRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GmsConversieApiApi - factory interface
 * @export
 */
export const GmsConversieApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GmsConversieApiApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GmsConversieCommunicatieVersturen</li></ul>
         * @summary Haalt de resultaten op van GMS conversie.
         * @param {string} [mutatiedatum] 
         * @param {number} [mutatiereden] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gmsConversieGetResults(mutatiedatum?: string, mutatiereden?: number, options?: any): AxiosPromise<CollectionResultOfCrmGmsGetGmsConversieLogsResponse> {
            return localVarFp.gmsConversieGetResults(mutatiedatum, mutatiereden, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GmsConversieCommunicatieVersturen</li></ul>
         * @summary Verstuurt communicatie richting klanten m.b.t. gms conversie.
         * @param {boolean} [testRun] 
         * @param {CrmGmsVerstuurGmsCommunicatieRequest} [crmGmsVerstuurGmsCommunicatieRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gmsConversieVerstuurCommunicatie(testRun?: boolean, crmGmsVerstuurGmsCommunicatieRequest?: CrmGmsVerstuurGmsCommunicatieRequest, options?: any): AxiosPromise<void> {
            return localVarFp.gmsConversieVerstuurCommunicatie(testRun, crmGmsVerstuurGmsCommunicatieRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GmsConversieApiApi - interface
 * @export
 * @interface GmsConversieApiApi
 */
export interface GmsConversieApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GmsConversieCommunicatieVersturen</li></ul>
     * @summary Haalt de resultaten op van GMS conversie.
     * @param {string} [mutatiedatum] 
     * @param {number} [mutatiereden] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmsConversieApiApiInterface
     */
    gmsConversieGetResults(mutatiedatum?: string, mutatiereden?: number, options?: any): AxiosPromise<CollectionResultOfCrmGmsGetGmsConversieLogsResponse>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GmsConversieCommunicatieVersturen</li></ul>
     * @summary Verstuurt communicatie richting klanten m.b.t. gms conversie.
     * @param {boolean} [testRun] 
     * @param {CrmGmsVerstuurGmsCommunicatieRequest} [crmGmsVerstuurGmsCommunicatieRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmsConversieApiApiInterface
     */
    gmsConversieVerstuurCommunicatie(testRun?: boolean, crmGmsVerstuurGmsCommunicatieRequest?: CrmGmsVerstuurGmsCommunicatieRequest, options?: any): AxiosPromise<void>;

}

/**
 * GmsConversieApiApi - object-oriented interface
 * @export
 * @class GmsConversieApiApi
 * @extends {BaseAPI}
 */
export class GmsConversieApiApi extends BaseAPI implements GmsConversieApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GmsConversieCommunicatieVersturen</li></ul>
     * @summary Haalt de resultaten op van GMS conversie.
     * @param {string} [mutatiedatum] 
     * @param {number} [mutatiereden] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmsConversieApiApi
     */
    public gmsConversieGetResults(mutatiedatum?: string, mutatiereden?: number, options?: any) {
        return GmsConversieApiApiFp(this.configuration).gmsConversieGetResults(mutatiedatum, mutatiereden, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GmsConversieCommunicatieVersturen</li></ul>
     * @summary Verstuurt communicatie richting klanten m.b.t. gms conversie.
     * @param {boolean} [testRun] 
     * @param {CrmGmsVerstuurGmsCommunicatieRequest} [crmGmsVerstuurGmsCommunicatieRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmsConversieApiApi
     */
    public gmsConversieVerstuurCommunicatie(testRun?: boolean, crmGmsVerstuurGmsCommunicatieRequest?: CrmGmsVerstuurGmsCommunicatieRequest, options?: any) {
        return GmsConversieApiApiFp(this.configuration).gmsConversieVerstuurCommunicatie(testRun, crmGmsVerstuurGmsCommunicatieRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MedewerkersApiApi - axios parameter creator
 * @export
 */
export const MedewerkersApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Lijst met behandelaars voor aanvragen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medewerkersGetBehandelaarsAanvragen: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/medewerkers/behandelaars-aanvragen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Lijst met behandelaars voor inspectie aanvragen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medewerkersGetBehandelaarsInspecties: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/medewerkers/behandelaars-inspectie-aanvragen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedewerkersApiApi - functional programming interface
 * @export
 */
export const MedewerkersApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedewerkersApiApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Lijst met behandelaars voor aanvragen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medewerkersGetBehandelaarsAanvragen(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmMedewerkersAfdelingGebruikers>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medewerkersGetBehandelaarsAanvragen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Lijst met behandelaars voor inspectie aanvragen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medewerkersGetBehandelaarsInspecties(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmMedewerkersMedewerkerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medewerkersGetBehandelaarsInspecties(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MedewerkersApiApi - factory interface
 * @export
 */
export const MedewerkersApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedewerkersApiApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Lijst met behandelaars voor aanvragen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medewerkersGetBehandelaarsAanvragen(options?: any): AxiosPromise<CollectionResultOfCrmMedewerkersAfdelingGebruikers> {
            return localVarFp.medewerkersGetBehandelaarsAanvragen(options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Lijst met behandelaars voor inspectie aanvragen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medewerkersGetBehandelaarsInspecties(options?: any): AxiosPromise<CollectionResultOfCrmMedewerkersMedewerkerDto> {
            return localVarFp.medewerkersGetBehandelaarsInspecties(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MedewerkersApiApi - interface
 * @export
 * @interface MedewerkersApiApi
 */
export interface MedewerkersApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Lijst met behandelaars voor aanvragen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedewerkersApiApiInterface
     */
    medewerkersGetBehandelaarsAanvragen(options?: any): AxiosPromise<CollectionResultOfCrmMedewerkersAfdelingGebruikers>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Lijst met behandelaars voor inspectie aanvragen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedewerkersApiApiInterface
     */
    medewerkersGetBehandelaarsInspecties(options?: any): AxiosPromise<CollectionResultOfCrmMedewerkersMedewerkerDto>;

}

/**
 * MedewerkersApiApi - object-oriented interface
 * @export
 * @class MedewerkersApiApi
 * @extends {BaseAPI}
 */
export class MedewerkersApiApi extends BaseAPI implements MedewerkersApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Lijst met behandelaars voor aanvragen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedewerkersApiApi
     */
    public medewerkersGetBehandelaarsAanvragen(options?: any) {
        return MedewerkersApiApiFp(this.configuration).medewerkersGetBehandelaarsAanvragen(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Lijst met behandelaars voor inspectie aanvragen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedewerkersApiApi
     */
    public medewerkersGetBehandelaarsInspecties(options?: any) {
        return MedewerkersApiApiFp(this.configuration).medewerkersGetBehandelaarsInspecties(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OntdubbelRelatieContactpersonenApi - axios parameter creator
 * @export
 */
export const OntdubbelRelatieContactpersonenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Tijdelijk endpoint om contactpersonen te ontdubbelen in Level
         * @param {boolean} [verwijderenOverslaan] 
         * @param {Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>} [crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon: async (verwijderenOverslaan?: boolean, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto?: Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/relatie/contactpersonen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (verwijderenOverslaan !== undefined) {
                localVarQueryParameter['verwijderenOverslaan'] = verwijderenOverslaan;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OntdubbelRelatieContactpersonenApi - functional programming interface
 * @export
 */
export const OntdubbelRelatieContactpersonenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OntdubbelRelatieContactpersonenApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Tijdelijk endpoint om contactpersonen te ontdubbelen in Level
         * @param {boolean} [verwijderenOverslaan] 
         * @param {Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>} [crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan?: boolean, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto?: Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OntdubbelRelatieContactpersonenApi - factory interface
 * @export
 */
export const OntdubbelRelatieContactpersonenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OntdubbelRelatieContactpersonenApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Tijdelijk endpoint om contactpersonen te ontdubbelen in Level
         * @param {boolean} [verwijderenOverslaan] 
         * @param {Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>} [crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan?: boolean, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto?: Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>, options?: any): AxiosPromise<CollectionResultOfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult> {
            return localVarFp.ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OntdubbelRelatieContactpersonenApi - interface
 * @export
 * @interface OntdubbelRelatieContactpersonenApi
 */
export interface OntdubbelRelatieContactpersonenApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Tijdelijk endpoint om contactpersonen te ontdubbelen in Level
     * @param {boolean} [verwijderenOverslaan] 
     * @param {Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>} [crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OntdubbelRelatieContactpersonenApiInterface
     */
    ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan?: boolean, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto?: Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>, options?: any): AxiosPromise<CollectionResultOfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult>;

}

/**
 * OntdubbelRelatieContactpersonenApi - object-oriented interface
 * @export
 * @class OntdubbelRelatieContactpersonenApi
 * @extends {BaseAPI}
 */
export class OntdubbelRelatieContactpersonenApi extends BaseAPI implements OntdubbelRelatieContactpersonenApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Tijdelijk endpoint om contactpersonen te ontdubbelen in Level
     * @param {boolean} [verwijderenOverslaan] 
     * @param {Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>} [crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OntdubbelRelatieContactpersonenApi
     */
    public ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan?: boolean, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto?: Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>, options?: any) {
        return OntdubbelRelatieContactpersonenApiFp(this.configuration).ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PolisBescheidenApiApi - axios parameter creator
 * @export
 */
export const PolisBescheidenApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Verwerkt gefiateerde pakketpolissen en verstuurt royementsbevestigingen. Wanneer geen datum opgegeven wordt, wordt de huidige datum gebruikt. <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Start de verwerking van geroyeerde toekomst royementen voor een opgegeven datum
         * @param {string} [datum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polisBescheidenVerwerkGeroyeerdeToekomstRoyementen: async (datum?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/polisbescheiden/geroyeerde-toekomst-royementen/verwerk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (datum !== undefined) {
                localVarQueryParameter['datum'] = (datum as any instanceof Date) ?
                    (datum as any).toISOString() :
                    datum;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PolisBescheidenApiApi - functional programming interface
 * @export
 */
export const PolisBescheidenApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PolisBescheidenApiApiAxiosParamCreator(configuration)
    return {
        /**
         * Verwerkt gefiateerde pakketpolissen en verstuurt royementsbevestigingen. Wanneer geen datum opgegeven wordt, wordt de huidige datum gebruikt. <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Start de verwerking van geroyeerde toekomst royementen voor een opgegeven datum
         * @param {string} [datum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async polisBescheidenVerwerkGeroyeerdeToekomstRoyementen(datum?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.polisBescheidenVerwerkGeroyeerdeToekomstRoyementen(datum, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PolisBescheidenApiApi - factory interface
 * @export
 */
export const PolisBescheidenApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PolisBescheidenApiApiFp(configuration)
    return {
        /**
         * Verwerkt gefiateerde pakketpolissen en verstuurt royementsbevestigingen. Wanneer geen datum opgegeven wordt, wordt de huidige datum gebruikt. <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Start de verwerking van geroyeerde toekomst royementen voor een opgegeven datum
         * @param {string} [datum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polisBescheidenVerwerkGeroyeerdeToekomstRoyementen(datum?: string, options?: any): AxiosPromise<string> {
            return localVarFp.polisBescheidenVerwerkGeroyeerdeToekomstRoyementen(datum, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PolisBescheidenApiApi - interface
 * @export
 * @interface PolisBescheidenApiApi
 */
export interface PolisBescheidenApiApiInterface {
    /**
     * Verwerkt gefiateerde pakketpolissen en verstuurt royementsbevestigingen. Wanneer geen datum opgegeven wordt, wordt de huidige datum gebruikt. <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Start de verwerking van geroyeerde toekomst royementen voor een opgegeven datum
     * @param {string} [datum] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolisBescheidenApiApiInterface
     */
    polisBescheidenVerwerkGeroyeerdeToekomstRoyementen(datum?: string, options?: any): AxiosPromise<string>;

}

/**
 * PolisBescheidenApiApi - object-oriented interface
 * @export
 * @class PolisBescheidenApiApi
 * @extends {BaseAPI}
 */
export class PolisBescheidenApiApi extends BaseAPI implements PolisBescheidenApiApiInterface {
    /**
     * Verwerkt gefiateerde pakketpolissen en verstuurt royementsbevestigingen. Wanneer geen datum opgegeven wordt, wordt de huidige datum gebruikt. <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Start de verwerking van geroyeerde toekomst royementen voor een opgegeven datum
     * @param {string} [datum] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolisBescheidenApiApi
     */
    public polisBescheidenVerwerkGeroyeerdeToekomstRoyementen(datum?: string, options?: any) {
        return PolisBescheidenApiApiFp(this.configuration).polisBescheidenVerwerkGeroyeerdeToekomstRoyementen(datum, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RelatiesApiApi - axios parameter creator
 * @export
 */
export const RelatiesApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.NaselectieInzien</li></ul>
         * @summary Haal naselecties op voor een relatie
         * @param {number} relatienummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relatiesGetNaselecties: async (relatienummer: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'relatienummer' is not null or undefined
            assertParamExists('relatiesGetNaselecties', 'relatienummer', relatienummer)
            const localVarPath = `/api/v1/relaties/{relatienummer}/naselecties`
                .replace(`{${"relatienummer"}}`, encodeURIComponent(String(relatienummer)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RelatiesApiApi - functional programming interface
 * @export
 */
export const RelatiesApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RelatiesApiApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.NaselectieInzien</li></ul>
         * @summary Haal naselecties op voor een relatie
         * @param {number} relatienummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async relatiesGetNaselecties(relatienummer: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmRelationsGetNaselectiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.relatiesGetNaselecties(relatienummer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RelatiesApiApi - factory interface
 * @export
 */
export const RelatiesApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RelatiesApiApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.NaselectieInzien</li></ul>
         * @summary Haal naselecties op voor een relatie
         * @param {number} relatienummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relatiesGetNaselecties(relatienummer: number, options?: any): AxiosPromise<CollectionResultOfCrmRelationsGetNaselectiesResponse> {
            return localVarFp.relatiesGetNaselecties(relatienummer, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RelatiesApiApi - interface
 * @export
 * @interface RelatiesApiApi
 */
export interface RelatiesApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.NaselectieInzien</li></ul>
     * @summary Haal naselecties op voor een relatie
     * @param {number} relatienummer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatiesApiApiInterface
     */
    relatiesGetNaselecties(relatienummer: number, options?: any): AxiosPromise<CollectionResultOfCrmRelationsGetNaselectiesResponse>;

}

/**
 * RelatiesApiApi - object-oriented interface
 * @export
 * @class RelatiesApiApi
 * @extends {BaseAPI}
 */
export class RelatiesApiApi extends BaseAPI implements RelatiesApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.NaselectieInzien</li></ul>
     * @summary Haal naselecties op voor een relatie
     * @param {number} relatienummer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatiesApiApi
     */
    public relatiesGetNaselecties(relatienummer: number, options?: any) {
        return RelatiesApiApiFp(this.configuration).relatiesGetNaselecties(relatienummer, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TussenpersonenApiApi - axios parameter creator
 * @export
 */
export const TussenpersonenApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
         * @summary Haal alle adviseurs op, standaard maatschappij-, systeem- en webgebruikeradviseurs uitgesloten
         * @param {boolean} [inclusiefMaatschappijen] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tussenpersonenGet: async (inclusiefMaatschappijen?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tussenpersonen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (inclusiefMaatschappijen !== undefined) {
                localVarQueryParameter['inclusiefMaatschappijen'] = inclusiefMaatschappijen;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TussenpersonenApiApi - functional programming interface
 * @export
 */
export const TussenpersonenApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TussenpersonenApiApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
         * @summary Haal alle adviseurs op, standaard maatschappij-, systeem- en webgebruikeradviseurs uitgesloten
         * @param {boolean} [inclusiefMaatschappijen] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tussenpersonenGet(inclusiefMaatschappijen?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmAdviseursGetAdviseursDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tussenpersonenGet(inclusiefMaatschappijen, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TussenpersonenApiApi - factory interface
 * @export
 */
export const TussenpersonenApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TussenpersonenApiApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
         * @summary Haal alle adviseurs op, standaard maatschappij-, systeem- en webgebruikeradviseurs uitgesloten
         * @param {boolean} [inclusiefMaatschappijen] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tussenpersonenGet(inclusiefMaatschappijen?: boolean, options?: any): AxiosPromise<CollectionResultOfCrmAdviseursGetAdviseursDto> {
            return localVarFp.tussenpersonenGet(inclusiefMaatschappijen, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TussenpersonenApiApi - interface
 * @export
 * @interface TussenpersonenApiApi
 */
export interface TussenpersonenApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
     * @summary Haal alle adviseurs op, standaard maatschappij-, systeem- en webgebruikeradviseurs uitgesloten
     * @param {boolean} [inclusiefMaatschappijen] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TussenpersonenApiApiInterface
     */
    tussenpersonenGet(inclusiefMaatschappijen?: boolean, options?: any): AxiosPromise<CollectionResultOfCrmAdviseursGetAdviseursDto>;

}

/**
 * TussenpersonenApiApi - object-oriented interface
 * @export
 * @class TussenpersonenApiApi
 * @extends {BaseAPI}
 */
export class TussenpersonenApiApi extends BaseAPI implements TussenpersonenApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
     * @summary Haal alle adviseurs op, standaard maatschappij-, systeem- en webgebruikeradviseurs uitgesloten
     * @param {boolean} [inclusiefMaatschappijen] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TussenpersonenApiApi
     */
    public tussenpersonenGet(inclusiefMaatschappijen?: boolean, options?: any) {
        return TussenpersonenApiApiFp(this.configuration).tussenpersonenGet(inclusiefMaatschappijen, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VeelgesteldeVragenBeheerApi - axios parameter creator
 * @export
 */
export const VeelgesteldeVragenBeheerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haalt categorieën en veelgestelde vragen voor beheer op.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/veelgestelde-vragen/beheer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Maakt een categorie voor veelgestelde vragen aan.
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerMaakCategorie: async (crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/veelgestelde-vragen/beheer/categorieen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Maakt een veelgestelde vraag aan.
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerMaakVraag: async (crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/veelgestelde-vragen/beheer/vragen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Verwijdert een lege categorie voor veelgestelde vragen.
         * @param {string} categorieId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerVerwijderCategorie: async (categorieId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'categorieId' is not null or undefined
            assertParamExists('veelgesteldeVragenBeheerVerwijderCategorie', 'categorieId', categorieId)
            const localVarPath = `/api/v1/veelgestelde-vragen/beheer/categorieen/{categorieId}`
                .replace(`{${"categorieId"}}`, encodeURIComponent(String(categorieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Verwijdert een veelgestelde vraag.
         * @param {string} vraagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerVerwijderVraag: async (vraagId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vraagId' is not null or undefined
            assertParamExists('veelgesteldeVragenBeheerVerwijderVraag', 'vraagId', vraagId)
            const localVarPath = `/api/v1/veelgestelde-vragen/beheer/vragen/{vraagId}`
                .replace(`{${"vraagId"}}`, encodeURIComponent(String(vraagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Werkt een categorie voor veelgestelde vragen bij.
         * @param {string} categorieId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerWerkCategorieBij: async (categorieId: string, crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'categorieId' is not null or undefined
            assertParamExists('veelgesteldeVragenBeheerWerkCategorieBij', 'categorieId', categorieId)
            const localVarPath = `/api/v1/veelgestelde-vragen/beheer/categorieen/{categorieId}`
                .replace(`{${"categorieId"}}`, encodeURIComponent(String(categorieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Werkt een veelgestelde vraag bij.
         * @param {string} vraagId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerWerkVraagBij: async (vraagId: string, crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vraagId' is not null or undefined
            assertParamExists('veelgesteldeVragenBeheerWerkVraagBij', 'vraagId', vraagId)
            const localVarPath = `/api/v1/veelgestelde-vragen/beheer/vragen/{vraagId}`
                .replace(`{${"vraagId"}}`, encodeURIComponent(String(vraagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Wijzigt de volgorde van een categorie voor veelgestelde vragen.
         * @param {string} categorieId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto} [crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerWijzigCategorieVolgorde: async (categorieId: string, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto?: CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'categorieId' is not null or undefined
            assertParamExists('veelgesteldeVragenBeheerWijzigCategorieVolgorde', 'categorieId', categorieId)
            const localVarPath = `/api/v1/veelgestelde-vragen/beheer/categorieen/{categorieId}/volgorde`
                .replace(`{${"categorieId"}}`, encodeURIComponent(String(categorieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Wijzigt de volgorde van een veelgestelde vraag binnen de categorie.
         * @param {string} vraagId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto} [crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerWijzigVraagVolgorde: async (vraagId: string, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto?: CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vraagId' is not null or undefined
            assertParamExists('veelgesteldeVragenBeheerWijzigVraagVolgorde', 'vraagId', vraagId)
            const localVarPath = `/api/v1/veelgestelde-vragen/beheer/vragen/{vraagId}/volgorde`
                .replace(`{${"vraagId"}}`, encodeURIComponent(String(vraagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VeelgesteldeVragenBeheerApi - functional programming interface
 * @export
 */
export const VeelgesteldeVragenBeheerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VeelgesteldeVragenBeheerApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haalt categorieën en veelgestelde vragen voor beheer op.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async veelgesteldeVragenBeheerGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.veelgesteldeVragenBeheerGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Maakt een categorie voor veelgestelde vragen aan.
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async veelgesteldeVragenBeheerMaakCategorie(crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.veelgesteldeVragenBeheerMaakCategorie(crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Maakt een veelgestelde vraag aan.
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async veelgesteldeVragenBeheerMaakVraag(crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.veelgesteldeVragenBeheerMaakVraag(crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Verwijdert een lege categorie voor veelgestelde vragen.
         * @param {string} categorieId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async veelgesteldeVragenBeheerVerwijderCategorie(categorieId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.veelgesteldeVragenBeheerVerwijderCategorie(categorieId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Verwijdert een veelgestelde vraag.
         * @param {string} vraagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async veelgesteldeVragenBeheerVerwijderVraag(vraagId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.veelgesteldeVragenBeheerVerwijderVraag(vraagId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Werkt een categorie voor veelgestelde vragen bij.
         * @param {string} categorieId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async veelgesteldeVragenBeheerWerkCategorieBij(categorieId: string, crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.veelgesteldeVragenBeheerWerkCategorieBij(categorieId, crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Werkt een veelgestelde vraag bij.
         * @param {string} vraagId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async veelgesteldeVragenBeheerWerkVraagBij(vraagId: string, crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.veelgesteldeVragenBeheerWerkVraagBij(vraagId, crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Wijzigt de volgorde van een categorie voor veelgestelde vragen.
         * @param {string} categorieId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto} [crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async veelgesteldeVragenBeheerWijzigCategorieVolgorde(categorieId: string, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto?: CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.veelgesteldeVragenBeheerWijzigCategorieVolgorde(categorieId, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Wijzigt de volgorde van een veelgestelde vraag binnen de categorie.
         * @param {string} vraagId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto} [crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async veelgesteldeVragenBeheerWijzigVraagVolgorde(vraagId: string, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto?: CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.veelgesteldeVragenBeheerWijzigVraagVolgorde(vraagId, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VeelgesteldeVragenBeheerApi - factory interface
 * @export
 */
export const VeelgesteldeVragenBeheerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VeelgesteldeVragenBeheerApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haalt categorieën en veelgestelde vragen voor beheer op.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerGet(options?: any): AxiosPromise<CollectionResultOfCrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie> {
            return localVarFp.veelgesteldeVragenBeheerGet(options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Maakt een categorie voor veelgestelde vragen aan.
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerMaakCategorie(crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options?: any): AxiosPromise<string> {
            return localVarFp.veelgesteldeVragenBeheerMaakCategorie(crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Maakt een veelgestelde vraag aan.
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerMaakVraag(crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options?: any): AxiosPromise<string> {
            return localVarFp.veelgesteldeVragenBeheerMaakVraag(crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Verwijdert een lege categorie voor veelgestelde vragen.
         * @param {string} categorieId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerVerwijderCategorie(categorieId: string, options?: any): AxiosPromise<void> {
            return localVarFp.veelgesteldeVragenBeheerVerwijderCategorie(categorieId, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Verwijdert een veelgestelde vraag.
         * @param {string} vraagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerVerwijderVraag(vraagId: string, options?: any): AxiosPromise<void> {
            return localVarFp.veelgesteldeVragenBeheerVerwijderVraag(vraagId, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Werkt een categorie voor veelgestelde vragen bij.
         * @param {string} categorieId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerWerkCategorieBij(categorieId: string, crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options?: any): AxiosPromise<void> {
            return localVarFp.veelgesteldeVragenBeheerWerkCategorieBij(categorieId, crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Werkt een veelgestelde vraag bij.
         * @param {string} vraagId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerWerkVraagBij(vraagId: string, crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options?: any): AxiosPromise<void> {
            return localVarFp.veelgesteldeVragenBeheerWerkVraagBij(vraagId, crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Wijzigt de volgorde van een categorie voor veelgestelde vragen.
         * @param {string} categorieId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto} [crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerWijzigCategorieVolgorde(categorieId: string, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto?: CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options?: any): AxiosPromise<void> {
            return localVarFp.veelgesteldeVragenBeheerWijzigCategorieVolgorde(categorieId, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Wijzigt de volgorde van een veelgestelde vraag binnen de categorie.
         * @param {string} vraagId 
         * @param {CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto} [crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veelgesteldeVragenBeheerWijzigVraagVolgorde(vraagId: string, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto?: CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options?: any): AxiosPromise<void> {
            return localVarFp.veelgesteldeVragenBeheerWijzigVraagVolgorde(vraagId, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VeelgesteldeVragenBeheerApi - interface
 * @export
 * @interface VeelgesteldeVragenBeheerApi
 */
export interface VeelgesteldeVragenBeheerApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
     * @summary Haalt categorieën en veelgestelde vragen voor beheer op.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApiInterface
     */
    veelgesteldeVragenBeheerGet(options?: any): AxiosPromise<CollectionResultOfCrmVeelgesteldeVragenGetVeelgesteldeVragenVoorBeheerCategorie>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Maakt een categorie voor veelgestelde vragen aan.
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApiInterface
     */
    veelgesteldeVragenBeheerMaakCategorie(crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options?: any): AxiosPromise<string>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Maakt een veelgestelde vraag aan.
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApiInterface
     */
    veelgesteldeVragenBeheerMaakVraag(crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options?: any): AxiosPromise<string>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Verwijdert een lege categorie voor veelgestelde vragen.
     * @param {string} categorieId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApiInterface
     */
    veelgesteldeVragenBeheerVerwijderCategorie(categorieId: string, options?: any): AxiosPromise<void>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Verwijdert een veelgestelde vraag.
     * @param {string} vraagId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApiInterface
     */
    veelgesteldeVragenBeheerVerwijderVraag(vraagId: string, options?: any): AxiosPromise<void>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Werkt een categorie voor veelgestelde vragen bij.
     * @param {string} categorieId 
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApiInterface
     */
    veelgesteldeVragenBeheerWerkCategorieBij(categorieId: string, crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options?: any): AxiosPromise<void>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Werkt een veelgestelde vraag bij.
     * @param {string} vraagId 
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApiInterface
     */
    veelgesteldeVragenBeheerWerkVraagBij(vraagId: string, crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options?: any): AxiosPromise<void>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Wijzigt de volgorde van een categorie voor veelgestelde vragen.
     * @param {string} categorieId 
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto} [crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApiInterface
     */
    veelgesteldeVragenBeheerWijzigCategorieVolgorde(categorieId: string, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto?: CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options?: any): AxiosPromise<void>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Wijzigt de volgorde van een veelgestelde vraag binnen de categorie.
     * @param {string} vraagId 
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto} [crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApiInterface
     */
    veelgesteldeVragenBeheerWijzigVraagVolgorde(vraagId: string, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto?: CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options?: any): AxiosPromise<void>;

}

/**
 * VeelgesteldeVragenBeheerApi - object-oriented interface
 * @export
 * @class VeelgesteldeVragenBeheerApi
 * @extends {BaseAPI}
 */
export class VeelgesteldeVragenBeheerApi extends BaseAPI implements VeelgesteldeVragenBeheerApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
     * @summary Haalt categorieën en veelgestelde vragen voor beheer op.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApi
     */
    public veelgesteldeVragenBeheerGet(options?: any) {
        return VeelgesteldeVragenBeheerApiFp(this.configuration).veelgesteldeVragenBeheerGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Maakt een categorie voor veelgestelde vragen aan.
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApi
     */
    public veelgesteldeVragenBeheerMaakCategorie(crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options?: any) {
        return VeelgesteldeVragenBeheerApiFp(this.configuration).veelgesteldeVragenBeheerMaakCategorie(crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Maakt een veelgestelde vraag aan.
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApi
     */
    public veelgesteldeVragenBeheerMaakVraag(crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options?: any) {
        return VeelgesteldeVragenBeheerApiFp(this.configuration).veelgesteldeVragenBeheerMaakVraag(crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Verwijdert een lege categorie voor veelgestelde vragen.
     * @param {string} categorieId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApi
     */
    public veelgesteldeVragenBeheerVerwijderCategorie(categorieId: string, options?: any) {
        return VeelgesteldeVragenBeheerApiFp(this.configuration).veelgesteldeVragenBeheerVerwijderCategorie(categorieId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Verwijdert een veelgestelde vraag.
     * @param {string} vraagId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApi
     */
    public veelgesteldeVragenBeheerVerwijderVraag(vraagId: string, options?: any) {
        return VeelgesteldeVragenBeheerApiFp(this.configuration).veelgesteldeVragenBeheerVerwijderVraag(vraagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Werkt een categorie voor veelgestelde vragen bij.
     * @param {string} categorieId 
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApi
     */
    public veelgesteldeVragenBeheerWerkCategorieBij(categorieId: string, crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options?: any) {
        return VeelgesteldeVragenBeheerApiFp(this.configuration).veelgesteldeVragenBeheerWerkCategorieBij(categorieId, crmVeelgesteldeVragenVeelgesteldeVraagCategorieOpslaanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Werkt een veelgestelde vraag bij.
     * @param {string} vraagId 
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto} [crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApi
     */
    public veelgesteldeVragenBeheerWerkVraagBij(vraagId: string, crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto?: CrmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options?: any) {
        return VeelgesteldeVragenBeheerApiFp(this.configuration).veelgesteldeVragenBeheerWerkVraagBij(vraagId, crmVeelgesteldeVragenVeelgesteldeVraagOpslaanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Wijzigt de volgorde van een categorie voor veelgestelde vragen.
     * @param {string} categorieId 
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto} [crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApi
     */
    public veelgesteldeVragenBeheerWijzigCategorieVolgorde(categorieId: string, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto?: CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options?: any) {
        return VeelgesteldeVragenBeheerApiFp(this.configuration).veelgesteldeVragenBeheerWijzigCategorieVolgorde(categorieId, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Wijzigt de volgorde van een veelgestelde vraag binnen de categorie.
     * @param {string} vraagId 
     * @param {CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto} [crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VeelgesteldeVragenBeheerApi
     */
    public veelgesteldeVragenBeheerWijzigVraagVolgorde(vraagId: string, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto?: CrmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options?: any) {
        return VeelgesteldeVragenBeheerApiFp(this.configuration).veelgesteldeVragenBeheerWijzigVraagVolgorde(vraagId, crmVeelgesteldeVragenVeelgesteldeVraagVolgordeWijzigenDto, options).then((request) => request(this.axios, this.basePath));
    }
}


